<div class="d-flex gap-1">
                <span class="badge bg-secondary" *ngIf="weight">
                Vægt: <strong>{{ weight }}</strong>kg
            </span>
    <span class="badge bg-success">{{ packaging?.description }}</span>
    <span *ngIf="price"
          class="badge bg-secondary">Pris <strong>{{ price | currency:'DKK':'symbol':null:'da' }}</strong></span>
</div>

